export default "__VITE_ASSET__MyhQVZFI__"